<template>
  <svg
    width="117"
    height="185"
    viewBox="0 0 117 185"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 106.244V150.621"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M83.2822 106.244V150.621"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="0.67041"
      y="73.3232"
      width="125.476"
      height="11"
      rx="3"
      transform="rotate(-35.8466 0.67041 73.3232)"
      stroke="var(--contrastColor)"
      stroke-width="2"
    />
    <path
      d="M73.9565 20.2812L68.6209 12.9124C67.2058 10.958 64.902 9.76921 62.2162 9.60748C59.5304 9.44575 56.6826 10.3243 54.2994 12.0499L27.3418 31.5692C24.9586 33.2949 23.2352 35.7262 22.5506 38.3283C21.8661 40.9304 22.2765 43.4902 23.6915 45.4445L29.0271 52.8134"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 75H116V175C116 179.971 111.971 184 107 184H27C22.0294 184 18 179.971 18 175V75Z"
      stroke="var(--contrastColor)"
      stroke-width="2"
    />
    <path
      d="M100.011 39.2376C103.951 41.0387 108.604 39.3055 110.405 35.3664C112.206 31.4272 110.473 26.7738 106.534 24.9727C102.595 23.1715 97.9413 24.9047 96.1401 28.8439C94.339 32.7831 96.0722 37.4365 100.011 39.2376Z"
      fill="var(--contrastColor)"
      stroke="var(--contrastColor)"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M105.051 69.1681L99.331 58.2371L97.283 74.8592L88.2305 74.8592L87.1872 67.2831L75.5282 74.8592L67.7746 74.8592C67.6389 74.4379 67.5875 73.994 67.6234 73.5528C67.6592 73.1116 67.7816 72.6818 67.9836 72.2879C68.1856 71.894 68.4631 71.5437 68.8005 71.2571L86.085 52.1806L74.0756 55.0051C73.2539 55.2686 72.3624 55.206 71.5857 54.8303C70.8089 54.4547 70.2064 53.7946 69.9028 52.9869C69.5993 52.1793 69.618 51.2858 69.955 50.4915C70.2921 49.6972 70.9217 49.0629 71.7135 48.7201L87.7293 40.3666C89.1284 39.8505 90.6742 39.9047 92.0337 40.5176L104.261 46.1082C104.928 46.4152 105.529 46.8511 106.027 47.3908C106.526 47.9306 106.912 48.5636 107.165 49.2534L111.324 66.8315C111.544 67.6406 111.454 68.5027 111.071 69.2485C110.688 69.9943 110.04 70.57 109.254 70.8627C108.468 71.1553 107.601 71.1437 106.824 70.8302C106.046 70.5167 105.414 69.9239 105.051 69.1681Z"
      fill="var(--contrastColor)"
      stroke="var(--contrastColor)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: [],
};
</script>
<style scoped></style>
